import React from 'react';
import HebrewLabel from "./HebrewLabel";

const HyperLink = ({children, url = '.', ...props}) => {
    return <HebrewLabel {...props}>
        <a href={url} target='_blank' rel="noreferrer">
            {children}
        </a>
    </HebrewLabel>
};

export default HyperLink;